<template>
  <dialog-custom
    :centerDialogVisible="visible"
    title="添加/编辑"
    @handleCancel="() => $emit('close')"
    @handleConfirm="submit('dataForm')"
  >
    <el-form v-loading="loading" ref="dataForm" :model="dataForm" :rules="rules" label-width="100px">
      <el-form-item label="版本名称" prop="VersionName">
        <el-input v-model="dataForm.VersionName" placeholder="版本名称"/>
      </el-form-item>
      <el-form-item label="版本号" prop="VersionCode">
        <el-input v-model="dataForm.VersionCode" placeholder="版本号"/>
      </el-form-item>
      <el-form-item label="更新文件" prop="VersionPath">
        <upload-com-one :imageUrl="dataForm.VersionPath" folderName="apk" accept=".apk" @backData="backImg"/>
      </el-form-item>
      <el-form-item label="更新描述" prop="VersionDesc">
        <el-input v-model="dataForm.VersionDesc" type="textarea" placeholder="更新描述"/>
      </el-form-item>
    </el-form>
  </dialog-custom>
</template>

<script>
import DialogCustom from '@/components/DialogCustom'
import { addSoftVersionAcross as add } from '../api'
import uploadComOne from '@/components/Upload/uploadComOne.vue'
export default {
  components: {
    DialogCustom,
    uploadComOne
  },
  data() {
    return {
      visible: false,
      loading: false,
      dataForm: {
        'VersionPath': null,
        'VersionCode': null,
        'VersionName': null,
        'VersionDesc': null
      },
      rules: {
        VersionName: [{ required: true, message: '请输入', trigger: 'blur' }],
        VersionCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        VersionPath: [{ required: true, message: '请上传文件', trigger: 'blur' }]
      }
    }
  },
  methods: {
    backImg(e) {
      console.log(e)
      this.dataForm.VersionPath = e
    },
    init(row) {
      if (row) Object.assign(this.dataForm, row)
      this.$nextTick(() => {
        this.visible = true
      })
    },
    submit(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          this.loading = true
          add(this.dataForm).then(res => {
            this.$message.success('成功')
            this.visible = false
            this.$emit('close')
            this.$emit('refresh')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
